import './index.scss';
import errorIcon from 'url:@assets/icons/error-icon.svg'
import { useNavigate } from 'react-router-dom';

export default function ErrorView(
  props: {
    error: string,
    /** Defaults to "Error". */
    title?: string,
    /** Defaults to the error icon; pass null for no icon. */
    icon?: string | null,
    showButton?: boolean,
    buttonText?: string,
    buttonAction?: () => void,
    /** Centers the view in the page rather than sitting at its natural height. */
    fullHeight?: boolean
  }
) {
  const navigate = useNavigate();
  const icon = props.icon === undefined ? errorIcon : props.icon;

  return <div className={props.fullHeight ? 'error-view full-height' : 'error-view'}>
    {icon ? <img src={icon} alt='' aria-hidden='true' /> : null}
    <h1>{props.title ?? 'Error'}</h1>
    <p>{props.error}</p>

    {props.showButton !== false ? <a href="#" onClick={props.buttonAction ?? (() => navigate(-1))}>{props.buttonText ?? "Go Back"}</a> : null}
  </div>
}
